import { Icon } from '@chakra-ui/icons'

const BrokenModem = props => (
    <Icon viewBox="0 0 100 100" fill={'none'} {...props}>
        <path
            d="M98.5352 79.3846H1.46484V62.1646C2.95312 60.6764 3.7877 59.8418 5.27598 58.3535H94.7238C96.2121 59.8418 97.0467 60.6764 98.535 62.1646V79.3846H98.5352Z"
            fill="#A3A3A3"
        />
        <path
            d="M31.0803 73.2367H13.2668C10.8543 73.2367 8.89844 71.2809 8.89844 68.8684C8.89844 66.4559 10.8543 64.5 13.2668 64.5H31.0803C33.4928 64.5 35.4486 66.4559 35.4486 68.8684C35.4486 71.2811 33.4928 73.2367 31.0803 73.2367Z"
            fill="#F3C66C"
        />
        <path
            d="M15.1693 79.3848H5.07812V84.6443H15.1693V79.3848Z"
            fill="#A3A3A3"
        />
        <path
            d="M94.9213 79.3848H84.8301V84.6443H94.9213V79.3848Z"
            fill="#A3A3A3"
        />
        <path
            d="M16.9928 58.352H9.89648V16.8203C10.4686 16.2482 10.7893 15.9275 11.3613 15.3555H15.5279C16.1 15.9275 16.4207 16.2482 16.9928 16.8203V58.352Z"
            fill="#A89CB9"
        />
        <path
            d="M83.0078 58.352H90.1041V16.8203C89.532 16.2482 89.2113 15.9275 88.6393 15.3555H84.4727C83.9006 15.9275 83.5799 16.2482 83.0078 16.8203V58.352Z"
            fill="#A89CB9"
        />
        <path
            d="M11.1354 58.3535H5.27598L1.46484 62.1646V79.3846H7.32422V62.1646L11.1354 58.3535Z"
            fill="#5E5E5E"
        />
        <path
            d="M14.7578 68.8684C14.7578 66.4559 16.7137 64.5 19.1262 64.5H13.2668C10.8543 64.5 8.89844 66.4559 8.89844 68.8684C8.89844 71.2809 10.8543 73.2367 13.2668 73.2367H19.1262C16.7135 73.2367 14.7578 71.2811 14.7578 68.8684Z"
            fill="#F47473"
        />
        <path
            d="M10.9375 79.3848H5.07812V84.6443H10.9375V79.3848Z"
            fill="#5E5E5E"
        />
        <path
            d="M90.6895 79.3848H84.8301V84.6443H90.6895V79.3848Z"
            fill="#5E5E5E"
        />
        <path
            d="M92.3555 73.0352H85.4824V75.9648H92.3555V73.0352Z"
            fill="black"
        />
        <path
            d="M81.6133 73.0352H70.834V75.9648H81.6133V73.0352Z"
            fill="black"
        />
        <path
            d="M100 61.558L95.3307 56.8887H4.66934L0 61.558V80.8492H3.61328V86.109H16.6342V80.8492H83.366V86.109H96.3867V80.8492H100V61.558ZM13.7045 83.1793H6.54297V80.8492H13.7045V83.1793ZM93.457 83.1793H86.2955V80.8492H93.457V83.1793ZM97.0703 77.9195H2.92969V62.7713L5.88281 59.8182H94.1172L97.0703 62.7713V77.9195Z"
            fill="black"
        />
        <path
            d="M92.3535 61.7715H89.4238V64.7012H92.3535V61.7715Z"
            fill="white"
        />
        <path
            d="M82.5879 61.7715H67.7441V64.7012H82.5879V61.7715Z"
            fill="white"
        />
        <path
            d="M87.4707 61.7715H84.541V64.7012H87.4707V61.7715Z"
            fill="white"
        />
        <path
            d="M21.6621 67.4043H12.9219V70.334H21.6621V67.4043Z"
            fill="white"
        />
        <path
            d="M26.5449 67.4043H23.6152V70.334H26.5449V67.4043Z"
            fill="white"
        />
        <path
            d="M31.4277 67.4043H28.498V70.334H31.4277V67.4043Z"
            fill="white"
        />
        <path
            d="M51.1074 67.4043H48.1777V70.334H51.1074V67.4043Z"
            fill="black"
        />
        <path
            d="M55.9902 67.4043H53.0605V70.334H55.9902V67.4043Z"
            fill="black"
        />
        <path d="M60.873 67.4043H57.9434V70.334H60.873V67.4043Z" fill="black" />
        <path
            d="M46.2246 67.4043H43.2949V70.334H46.2246V67.4043Z"
            fill="black"
        />
        <path
            d="M31.0803 63.0352H13.2668C10.0504 63.0352 7.43359 65.6518 7.43359 68.8684C7.43359 72.085 10.0504 74.7016 13.2668 74.7016H31.0803C34.2967 74.7016 36.9135 72.085 36.9135 68.8684C36.9135 65.6518 34.2967 63.0352 31.0803 63.0352ZM31.0803 71.7721H13.2668C11.6658 71.7721 10.3633 70.4695 10.3633 68.8686C10.3633 67.2676 11.6658 65.965 13.2668 65.965H31.0803C32.6812 65.965 33.9838 67.2676 33.9838 68.8686C33.9838 70.4695 32.6812 71.7721 31.0803 71.7721Z"
            fill="black"
        />
        <path
            d="M11.3662 17.7502L11.9807 17.0841H14.9722L15.5869 17.7502V58.3984H18.5547V16.4178L16.2015 13.8672H10.7515L8.39844 16.4178V58.3984H11.3662V17.7502Z"
            fill="black"
        />
        <path
            d="M84.4131 17.7502L85.0276 17.0841H88.0191L88.6338 17.7502V58.3984H91.6016V16.418L89.2483 13.8672H83.7983L81.4453 16.418V58.3984H84.4131V17.7502Z"
            fill="black"
        />
        <path
            d="M88.0195 51.293H85.0898V54.1553H88.0195V51.293Z"
            fill="black"
        />
        <path
            d="M88.0195 46.4102H85.0898V49.3398H88.0195V46.4102Z"
            fill="black"
        />
        <path
            d="M88.0195 41.5273H85.0898V44.457H88.0195V41.5273Z"
            fill="black"
        />
        <path
            d="M63.7767 34.1748L66.8379 31.1135C64.6268 28.9022 62.0018 27.1481 59.1127 25.9514C56.2236 24.7546 53.1271 24.1387 50 24.1387C46.8729 24.1387 43.7764 24.7546 40.8873 25.9514C37.9983 27.1481 35.3732 28.9022 33.1621 31.1135L36.2233 34.1748C38.0323 32.3653 40.1801 30.9299 42.5439 29.9505C44.9077 28.9712 47.4413 28.4672 50 28.4672C52.5587 28.4672 55.0923 28.9712 57.4561 29.9505C59.8199 30.9299 61.9677 32.3653 63.7767 34.1748Z"
            fill="#F2F2F2"
        />
        <path
            d="M39.2852 37.2344L42.3464 40.2968C44.3766 38.267 47.1298 37.1268 50.0006 37.1268C52.8714 37.1268 55.6247 38.267 57.6548 40.2968L60.7161 37.2344C57.8738 34.393 54.0195 32.7969 50.0006 32.7969C45.9817 32.7969 42.1274 34.393 39.2852 37.2344Z"
            fill="#E5F1FF"
        />
        <path
            d="M49.9991 49.0333C51.7924 49.0333 53.2462 47.5796 53.2462 45.7862C53.2462 43.9929 51.7924 42.5391 49.9991 42.5391C48.2057 42.5391 46.752 43.9929 46.752 45.7862C46.752 47.5796 48.2057 49.0333 49.9991 49.0333Z"
            fill="#4CA0FE"
        />
        <path
            d="M63.1146 35.0709C63.2014 35.1578 63.3046 35.2267 63.4181 35.2737C63.5316 35.3207 63.6532 35.3449 63.7761 35.3449C63.899 35.3449 64.0206 35.3207 64.1341 35.2737C64.2476 35.2267 64.3508 35.1578 64.4376 35.0709L67.4993 32.0091C67.5862 31.9222 67.6551 31.8191 67.7021 31.7056C67.7491 31.5921 67.7733 31.4704 67.7733 31.3476C67.7733 31.2247 67.7491 31.1031 67.7021 30.9896C67.6551 30.8761 67.5862 30.773 67.4993 30.6861C65.2013 28.388 62.4731 26.5651 59.4706 25.3214C56.468 24.0776 53.2499 23.4375 49.9999 23.4375C46.75 23.4375 43.5319 24.0776 40.5293 25.3214C37.5268 26.5651 34.7986 28.388 32.5006 30.6861C32.4137 30.773 32.3448 30.8761 32.2978 30.9896C32.2508 31.1031 32.2266 31.2247 32.2266 31.3476C32.2266 31.4704 32.2508 31.5921 32.2978 31.7056C32.3448 31.8191 32.4137 31.9222 32.5006 32.0091L35.5623 35.0709C35.6491 35.1578 35.7523 35.2267 35.8658 35.2737C35.9793 35.3207 36.1009 35.3449 36.2238 35.3449C36.3466 35.3449 36.4683 35.3207 36.5818 35.2737C36.6953 35.2267 36.7985 35.1578 36.8853 35.0709C38.6074 33.3484 40.652 31.9821 42.9022 31.0499C45.1524 30.1177 47.5643 29.6379 49.9999 29.6379C52.4356 29.6379 54.8474 30.1177 57.0977 31.0499C59.3479 31.9821 61.3924 33.3484 63.1146 35.0709ZM36.2387 33.1012L34.4982 31.3608C38.7224 27.4689 44.2561 25.3083 49.9999 25.3083C55.7438 25.3083 61.2774 27.4689 65.5017 31.3608L63.7612 33.1012C59.9997 29.6694 55.0917 27.767 49.9999 27.767C44.9082 27.767 40.0002 29.6694 36.2387 33.1012Z"
            fill="#333333"
        />
        <path
            d="M61.6514 37.4703C61.6513 37.2223 61.5528 36.9846 61.3775 36.8092C58.3599 33.7924 54.2676 32.0977 50.0006 32.0977C45.7336 32.0977 41.6413 33.7924 38.6237 36.8092C38.5368 36.8961 38.4679 36.9992 38.4208 37.1128C38.3738 37.2263 38.3496 37.3479 38.3496 37.4708C38.3496 37.5936 38.3738 37.7153 38.4208 37.8288C38.4679 37.9423 38.5368 38.0454 38.6237 38.1323L41.6849 41.1941C41.8603 41.3695 42.0982 41.468 42.3462 41.468C42.5943 41.468 42.8322 41.3695 43.0076 41.1941C44.8622 39.3398 47.3774 38.298 50 38.298C52.6226 38.298 55.1378 39.3398 56.9924 41.1941C57.1678 41.3695 57.4057 41.468 57.6538 41.468C57.9018 41.468 58.1397 41.3695 58.3151 41.1941L61.3775 38.1318C61.4644 38.045 61.5333 37.9418 61.5803 37.8283C61.6272 37.7148 61.6514 37.5931 61.6514 37.4703ZM57.6282 39.2352C55.5 37.4224 52.7958 36.4267 50.0002 36.4267C47.2047 36.4267 44.5005 37.4224 42.3723 39.2352L40.6289 37.4918C43.2224 35.2203 46.5527 33.9681 50.0002 33.9681C53.4478 33.9681 56.7781 35.2203 59.3716 37.4918L57.6282 39.2352Z"
            fill="#333333"
        />
        <path
            d="M49.9989 41.8379C49.1716 41.8379 48.363 42.0832 47.6752 42.5428C46.9874 43.0024 46.4513 43.6557 46.1348 44.4199C45.8182 45.1842 45.7354 46.0252 45.8968 46.8365C46.0582 47.6478 46.4565 48.3931 47.0415 48.978C47.6264 49.5629 48.3716 49.9613 49.183 50.1227C49.9943 50.2841 50.8353 50.2013 51.5995 49.8847C52.3638 49.5681 53.017 49.0321 53.4766 48.3443C53.9362 47.6565 54.1815 46.8478 54.1816 46.0206C54.1803 44.9117 53.7392 43.8485 52.9551 43.0644C52.171 42.2802 51.1078 41.8392 49.9989 41.8379ZM49.9989 48.3322C49.5417 48.3322 49.0947 48.1966 48.7146 47.9425C48.3344 47.6885 48.0382 47.3274 47.8632 46.905C47.6883 46.4826 47.6425 46.0178 47.7317 45.5694C47.8209 45.1209 48.0411 44.7091 48.3644 44.3858C48.6878 44.0625 49.0997 43.8423 49.5481 43.7532C49.9965 43.664 50.4613 43.7098 50.8837 43.8848C51.3061 44.0598 51.6672 44.3561 51.9212 44.7363C52.1752 45.1164 52.3107 45.5634 52.3107 46.0206C52.3099 46.6335 52.0661 47.221 51.6327 47.6544C51.1993 48.0877 50.6118 48.3315 49.9989 48.3322Z"
            fill="#333333"
        />
        <path
            d="M99.408 79.5782L89.2288 61.948C88.3887 60.493 86.9187 59.7656 85.4486 59.7656L79.9746 72.9457L85.4486 86.1258H95.6278C98.988 86.1257 101.088 82.4882 99.408 79.5782Z"
            fill="#CB3434"
        />
        <path
            d="M81.6689 61.948L71.4898 79.5782C69.8096 82.4882 71.9097 86.1257 75.27 86.1257H85.4491V59.7656C83.9791 59.7656 82.509 60.493 81.6689 61.948Z"
            fill="#CB3434"
        />
        <path
            d="M86.8184 81.6765H85.4499L84.7656 80.308L85.4499 78.9395H86.8184V81.6765Z"
            fill="white"
        />
        <path
            d="M84.0801 78.9395H85.4486V81.6765H84.0801V78.9395Z"
            fill="white"
        />
        <path
            d="M86.8184 76.2017H85.4499L84.7656 71.4221L85.4499 66.6426H86.8184V76.2017Z"
            fill="white"
        />
        <path
            d="M84.0801 66.6426H85.4486V76.2017H84.0801V66.6426Z"
            fill="white"
        />
    </Icon>
)

const Info = props => (
    <Icon viewBox="0 0 32 32" fill={'none'} {...props}>
        <path
            d="M5.5 5.5H26.5V26.5H5.5V5.5Z"
            stroke="#333333"
            strokeWidth="3"
        />
        <path d="M16 22V13M16 12V9.5" stroke="#333333" strokeWidth="3" />
    </Icon>
)

const MarkReview = props => (
    <Icon viewBox="0 0 24 26" fill={'none'} {...props}>
        <path
            d="M23.1152 11.0527L19.0645 23.9551H5.48242L1.43066 11.0527L12.2734 2.24316L23.1152 11.0527Z"
            fill="white"
            stroke="#575757"
            strokeWidth="2"
        />
        <path
             d="M8.27344 17.5295V13.3928C8.27344 11.5761 8.27344 10.6678 8.85922 10.1034C9.44501 9.53906 10.3878 9.53906 12.2734 9.53906C14.159 9.53906 15.1019 9.53906 15.6876 10.1034C16.2734 10.6678 16.2734 11.5761 16.2734 13.3928V17.5295C16.2734 18.6824 16.2734 19.2589 15.887 19.4652C15.1387 19.8648 13.735 18.5317 13.0684 18.1303C12.6818 17.8975 12.4885 17.7811 12.2734 17.7811C12.0583 17.7811 11.865 17.8975 11.4784 18.1303C10.8118 18.5317 9.40817 19.8648 8.65986 19.4652C8.27344 19.2589 8.27344 18.6824 8.27344 17.5295Z"
            stroke="#737373"
            strokeWidth="0.75"
            strokeLinecap="round"
             stroke-linejoin="round"
        />
    </Icon>
)

const MarkedReview = props => (
    <Icon viewBox="0 0 24 26" fill={'none'} {...props}>
        <path
            d="M23.1152 10.9355L19.0645 23.8379H5.48242L1.43066 10.9355L12.2734 2.12598L23.1152 10.9355Z"
            fill="#F29100"
            stroke="#575757"
            strokeWidth="2"
        />
        <path
            d="M8.27344 17.4123V13.2756C8.27344 11.459 8.27344 10.5506 8.85922 9.98625C9.44501 9.42188 10.3878 9.42188 12.2734 9.42188C14.159 9.42188 15.1019 9.42188 15.6876 9.98625C16.2734 10.5506 16.2734 11.459 16.2734 13.2756V17.4123C16.2734 18.5652 16.2734 19.1417 15.887 19.348C15.1387 19.7476 13.735 18.4145 13.0684 18.0131C12.6818 17.7803 12.4885 17.6639 12.2734 17.6639C12.0583 17.6639 11.865 17.7803 11.4784 18.0131C10.8118 18.4145 9.40817 19.7476 8.65986 19.348C8.27344 19.1417 8.27344 18.5652 8.27344 17.4123Z"
            fill="white"
        />
        <path
            d="M10.7734 14.0885C10.7734 14.0885 11.2109 14.0885 11.6484 14.9219C11.6484 14.9219 13.0381 12.8385 14.2734 12.4219"
            stroke="#F29100"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
)

const AttemptFinished = props => (
    <Icon viewBox="0 0 96 96" fill={'none'} {...props}>
        <mask id="path-1-inside-1_161716_127937" fill="white">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.85547 0.959961H53.7755V17.76H70.0955V74.88H3.85547V0.959961Z"
            />
            <path d="M70.0955 17.76L53.7755 0.959961V17.76H70.0955Z" />
        </mask>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.85547 0.959961H53.7755V17.76H70.0955V74.88H3.85547V0.959961Z"
            fill="white"
        />
        <path
            d="M70.0955 17.76L53.7755 0.959961V17.76H70.0955Z"
            fill="#4CA0FE"
        />
        <path
            d="M70.0955 0.959961H71.5955V-0.540039H70.0955V0.959961ZM53.7755 0.959961V-0.540039H52.2755V0.959961H53.7755ZM70.0955 17.76V19.26H71.5955V17.76H70.0955ZM53.7755 17.76H52.2755V19.26H53.7755V17.76ZM53.7755 2.45996H70.0955V-0.540039H53.7755V2.45996ZM68.5955 0.959961V17.76H71.5955V0.959961H68.5955ZM52.2755 0.959961V17.76H55.2755V0.959961H52.2755ZM53.7755 19.26H70.0955V16.26H53.7755V19.26ZM3.85547 0.959961V-2.04004H0.855469V0.959961H3.85547ZM70.0955 74.88V77.88H73.0955V74.88H70.0955ZM3.85547 74.88H0.855469V77.88H3.85547V74.88ZM53.7755 0.959961L55.9273 -1.1304L55.0437 -2.04004H53.7755V0.959961ZM70.0955 17.76H73.0955V16.5427L72.2473 15.6696L70.0955 17.76ZM70.0955 71.88H3.85547V77.88H70.0955V71.88ZM6.85547 74.88V0.959961H0.855469V74.88H6.85547ZM3.85547 3.95996H53.7755V-2.04004H3.85547V3.95996ZM67.0955 17.76V74.88H73.0955V17.76H67.0955ZM51.6236 3.05032L67.9436 19.8503L72.2473 15.6696L55.9273 -1.1304L51.6236 3.05032Z"
            fill="#4CA0FE"
            mask="url(#path-1-inside-1_161716_127937)"
        />
        <path d="M12.0156 13.999H23.0156" stroke="#4CA0FE" strokeWidth="3" />
        <path d="M12.0156 35.999H23.0156" stroke="#4CA0FE" strokeWidth="3" />
        <path d="M12.0156 19.999H27.0156" stroke="#4CA0FE" strokeWidth="3" />
        <path d="M19.0156 25.999H42.0156" stroke="#4CA0FE" strokeWidth="3" />
        <path d="M19.0156 40.999H30.0156" stroke="#4CA0FE" strokeWidth="3" />
        <path d="M29.0156 19.999H34.0156" stroke="#4CA0FE" strokeWidth="3" />
        <path d="M12.0156 25.999H17.0156" stroke="#4CA0FE" strokeWidth="3" />
        <path d="M12.0156 40.999H17.0156" stroke="#4CA0FE" strokeWidth="3" />
        <rect
            x="26.4746"
            y="35.0996"
            width="58.44"
            height="58.44"
            rx="29.22"
            fill="white"
            stroke="#481110"
            strokeWidth="3"
        />
        <path
            d="M39.683 52.4238L56.8192 66.3542L57.8868 67.2221L58.8434 66.2333L90.6449 33.3629V51.4331L57.8009 82.2358L36.5075 60.8598L39.683 52.4238Z"
            fill="#9FB34E"
            stroke="#481110"
            strokeWidth="3"
        />
        <path
            d="M79.7701 13.5107L81.7836 7.01562L84.6491 7.90395L82.6356 14.399L79.7701 13.5107Z"
            fill="#481110"
        />
        <path
            d="M82.2545 18.2216L88.7495 20.2352L89.6378 17.3697L83.1428 15.3561L82.2545 18.2216Z"
            fill="#481110"
        />
        <path
            d="M78.8248 14.0029L72.3297 11.9893L71.4414 14.8548L77.9365 16.8683L78.8248 14.0029Z"
            fill="#481110"
        />
        <path
            d="M81.3053 18.7138L79.2917 25.2088L76.4262 24.3205L78.4398 17.8255L81.3053 18.7138Z"
            fill="#481110"
        />
    </Icon>
)

const Report = props => (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
        <path d="M4 22V2H20V22H4Z" stroke="#7C6A96" strokeWidth="3" />
        <path d="M9 4.625H15" stroke="#7C6A96" strokeWidth="3" />
        <path d="M8 18.5V13.5" stroke="#7C6A96" strokeWidth="3" />
        <path d="M16 18.5V15.5" stroke="#7C6A96" strokeWidth="3" />
        <path d="M12 18.5V11.5" stroke="#7C6A96" strokeWidth="3" />
    </Icon>
)

const QStateAnswered = props => (
    <Icon viewBox="0 0 48 48" fill={'none'} {...props}>
        <rect
            x="1.5"
            y="1.5"
            width="45"
            height="45"
            rx="22.5"
            fill="#0077FE"
            stroke="#454545"
            strokeWidth="3"
        />
    </Icon>
)

const QStateUnanswered = props => (
    <Icon viewBox="0 0 48 48" fill={'none'} {...props}>
        <rect
            x="1.5"
            y="1.5"
            width="45"
            height="45"
            fill="white"
            stroke="#454545"
            strokeWidth="3"
        />
    </Icon>
)

const QStateReviewAnswered = props => (
    <Icon viewBox="0 0 48 48" fill={'none'} {...props}>
        <path
            d="M10.0504 46.5L1.73615 20.0221L24 1.93271L46.2639 20.0221L37.9496 46.5H10.0504Z"
            fill="#F29100"
            stroke="#454545"
            strokeWidth="3"
        />
        <circle cx="40" cy="40" r="8" fill="#0077FE" />
    </Icon>
)

const QStateReviewUnanswered = props => (
    <Icon viewBox="0 0 48 48" fill={'none'} {...props}>
        <path
            d="M10.0504 46.5L1.73615 20.0221L24 1.93271L46.2639 20.0221L37.9496 46.5H10.0504Z"
            fill="#F29100"
            stroke="#454545"
            strokeWidth="3"
        />
    </Icon>
)

const CrossCompact = props => (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
        <rect
            x="1.5"
            y="1.5"
            width="21"
            height="21"
            stroke="#333333"
            strokeWidth="3"
        />
        <g clipPath="url(#clip0_162236_128439)">
            <path d="M6 6L18 18M18 6L6 18" stroke="#333333" strokeWidth="3" />
        </g>
        <defs>
            <clipPath id="clip0_162236_128439">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(4 4)"
                />
            </clipPath>
        </defs>
    </Icon>
)

const ReportIssueIcon = props => (
    <Icon viewBox="0 0 32 32" fill={'none'} {...props}>
        <path
            d="M11.5858 5.49097L20.3872 5.41416L26.665 11.5834L26.7418 20.3847L20.5726 26.6626L11.7712 26.7394L5.49341 20.5702L5.4166 11.7688L11.5858 5.49097Z"
            stroke="currentColor"
            strokeWidth="3"
        />
        <path d="M16 9V17" stroke="currentColor" strokeWidth="3" />
        <path d="M16 23V20" stroke="currentColor" strokeWidth="3" />
    </Icon>
)

const Recording = props => (
    <Icon viewBox="0 0 8 8" fill={'none'} {...props}>
        <circle cx="4" cy="4" r="4" fill="#EF3837" fillOpacity="0.32" />
        <circle cx="4" cy="4" r="2" fill="#EF3837" />
    </Icon>
)

const StartRecording = props => (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
        <circle cx="12" cy="13" r="10" fill="#FAFAFA" />
        <circle cx="12" cy="13" r="7" fill="#EF3837" />
    </Icon>
)

const StopRecording = props => (
    <Icon viewBox="0 0 25 24" fill={'none'} {...props}>
        <rect x="3.41406" y="3" width="18" height="18" fill="#EF3837" />
    </Icon>
)

const RecorderCircle = props => (
    <Icon viewBox="0 0 220 220" fill={'none'} {...props}>
        <g transform="translate(110,110)">
            <circle r="100" className="recorder-base" />
            <g transform="rotate(-90)">
                <circle r="100" className="recorder-progress" />
                <g id="recorder-pointer">
                    <circle
                        cx="100"
                        cy="0"
                        r="8"
                        className="recorder-pointer"
                    />
                </g>
            </g>
        </g>
    </Icon>
)

const HighSound = props => (
    <Icon viewBox={'0 0 48 48'} fill={'none'} {...props}>
        <rect x="6" y="12" width="8" height="24" fill="currentColor" />
        <rect x="20" y="8" width="8" height="32" fill="currentColor" />
        <rect x="34" y="12" width="8" height="24" fill="currentColor" />
    </Icon>
)

const AverageSound = props => (
    <Icon viewBox={'0 0 48 48'} fill={'none'} {...props}>
        <rect x="6" y="18" width="8" height="12" fill="currentColor" />
        <rect x="20" y="12" width="8" height="24" fill="currentColor" />
        <rect x="34" y="18" width="8" height="12" fill="currentColor" />
    </Icon>
)

const NoSound = props => (
    <Icon viewBox={'0 0 48 48'} fill={'none'} {...props}>
        <rect x="6" y="20" width="8" height="8" fill="currentColor" />
        <rect x="20" y="20" width="8" height="8" fill="currentColor" />
        <rect x="34" y="20" width="8" height="8" fill="currentColor" />
    </Icon>
)

const AudioUploadOverlay = props => (
    <Icon viewBox={'0 0 302 302'} fill={'none'} {...props}>
        <circle cx="151" cy="151" r="151" fill="#FAFAFA" fillOpacity="0.5" />
    </Icon>
)

const RetakeIcon = props => (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
        <path
            d="M20.7559 14.0661V6.25781H6.75586"
            stroke="#333333"
            strokeWidth="3"
        />
        <path
            d="M10.2559 2.06641L6.75586 6.6383L10.2559 10.4482"
            stroke="#333333"
            strokeWidth="3"
        />
        <path
            d="M3.25586 11.0003V18.8086H17.2559"
            stroke="#333333"
            strokeWidth="3"
        />
        <path
            d="M13.7559 23L17.2559 18.4281L13.7559 14.6182"
            stroke="#333333"
            strokeWidth="3"
        />
    </Icon>
)

const KalviumLogo = props => (
    <Icon viewBox="0 0 36 42" fill={'none'} {...props}>
        <path
            d="M1.71429 2.37785L0 39.6308L1.71429 42H36V2.37785L34.2857 0L1.71429 2.37785ZM6.15731 37.8314V24.3181L31.5593 37.8314H6.15731ZM31.5593 32.895L10.7002 22.1501L31.5593 11.5472V32.895ZM6.15499 20.073V6.62188H31.5593L6.15499 20.073Z"
            fill="#191919"
        />
        <path
            d="M0 0V39.6222H34.2857V0H0ZM4.44303 35.4536V21.9403L29.845 35.4536H4.44303ZM29.845 30.5172L8.9859 19.7722L29.845 9.16936V30.5172ZM4.44071 17.6952V4.24404H29.845L4.44071 17.6952Z"
            fill="currentColor"
        />
    </Icon>
)

const FileIcon = props => {
    return (
        <Icon viewBox="0 0 32 32" fill="none" {...props}>
            <path
                d="M17 3H6V29H25.9992V12M17 3L25.9992 12M17 3V12H25.9992"
                stroke="#333333"
                strokeWidth="3"
            />
        </Icon>
    )
}

const TrashCan = props => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M2.5 7.5H5.5M21.5 7.5H18.5M5.5 7.5L6.5 20.5H12H17.5L18.5 7.5M5.5 7.5H7.5H18.5"
                stroke="#333333"
                strokeWidth="3"
            />
            <path d="M7.75 3.5H16.25" stroke="#333333" strokeWidth="3" />
        </Icon>
    )
}

export {
    AttemptFinished,
    AudioUploadOverlay,
    AverageSound,
    BrokenModem,
    CrossCompact,
    FileIcon,
    HighSound,
    Info,
    KalviumLogo,
    MarkedReview,
    MarkReview,
    NoSound,
    QStateAnswered,
    QStateReviewAnswered,
    QStateReviewUnanswered,
    QStateUnanswered,
    RecorderCircle,
    Recording,
    Report,
    ReportIssueIcon,
    RetakeIcon,
    StartRecording,
    StopRecording,
    TrashCan,
}
